import { StyleSheet } from 'react-native'

const useStyles = (theme, isTablet) => StyleSheet.create({
  flipCard: {
    height: '100%'
  },
  flipCardBack: {
    position: 'absolute',
    width: '100%',
    height: '100%'
  },
  description: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  status: {
    paddingHorizontal: 10,
    paddingVertical: 3,
    borderRadius: 3
  },
  tabs: {
    backgroundColor: theme.CARD_BACKGROUND,
    height: 50,
    shadowOffset: {
      width: 0,
      height: isTablet ? 4 : -4
    },
    shadowOpacity: 0.05,
    shadowRadius: 3
  }
})

export default useStyles
